import React, { Dispatch, SetStateAction } from "react";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";
import Flex from "../../../../../DefaultStyles/Flex";
import RadioBtn from "../../../../../Button/RadioBtn";
import ToolTip from "../../../../../Modal/ToolTip";

interface Props {
  party?: {
    state: {
      all: boolean;
      before: boolean;
      start: boolean;
      end: boolean;
    };
    role: {
      all: boolean;
      owner: boolean;
      member: boolean;
    };
  };
  setParty?: Dispatch<
    SetStateAction<{
      state: {
        all: boolean;
        before: boolean;
        start: boolean;
        end: boolean;
      };
      role: {
        all: boolean;
        owner: boolean;
        member: boolean;
      };
    }>
  >;
  isEditMode: boolean;
}

export default function FaqPartyRoleInput({
  party,
  setParty,
  isEditMode,
}: Props) {
  const state = {
    all: false,
    owner: false,
    member: false,
  };

  return (
    <FaqDetailRow>
      <FaqDetailLabel>
        파티 역할 선택
        <ToolTip
          msg="나의 파티, 도움말에 표시될 때 해당 파티의 역할"
          iconSize={18}
          direction="bottom"
        />
      </FaqDetailLabel>

      <Flex gapSize={58}>
        <RadioBtn
          label="전체"
          noTooltip={true}
          check={party?.role?.all}
          clickEvent={() => {
            if (setParty)
              setParty((prev) => ({
                ...prev,
                role: {
                  ...state,
                  all: !prev?.role?.all,
                },
              }));
          }}
          disabled={!isEditMode}
        />

        <RadioBtn
          label="파티장"
          noTooltip={true}
          check={party?.role?.owner}
          clickEvent={() => {
            if (setParty)
              setParty((prev) => ({
                ...prev,
                role: {
                  ...state,
                  owner: !prev?.role?.owner,
                },
              }));
          }}
          disabled={!isEditMode}
        />

        <RadioBtn
          label="파티원"
          noTooltip={true}
          check={party?.role?.member}
          clickEvent={() => {
            if (setParty)
              setParty((prev) => ({
                ...prev,
                role: {
                  ...state,
                  member: !prev?.role?.member,
                },
              }));
          }}
          disabled={!isEditMode}
        />
      </Flex>
    </FaqDetailRow>
  );
}
